// extracted by mini-css-extract-plugin
export default {"overlay":"gi6aDyku","children":"T1En3nyu","speechBox":"IwCCwR5C","buttons":"Mu28jJE5","button":"ELqfO9gQ","imgBox":"hzekXpFt","img":"qYtG_xjX"};
    if(module.hot) {
      // 1721070004693
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  